class NSSCartTemplate extends HTMLElement {
  
  constructor() {
    super();

    this.debug = false;

    this.els = {
      buyboxSummaries: document.querySelectorAll(`nss-buybox-summary-variant`),
      buyboxStickyATCs: document.querySelectorAll(`nss-buybox-sticky-atc-variant`),
    }
  }

  connectedCallback() {
    if (this.debug) console.log(`[NSS][Cart Template] Connected.`);

    this.initCartTemplate();
  }

  async apiAddToCart(e) {
    const formData = new FormData(e.target);

    return fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      body: formData,
    })
      .then((response) => {
        return response.json();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  async apiUpdate(updates) {
    return fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ updates }),
    })
      .then((response) => {
        return response.json();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  async apiChange(changes) {
    return fetch(window.Shopify.routes.root + "cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(changes),
    })
      .then((response) => {
        return response.json();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  async fetchCartSection() {
    const parser = new DOMParser(),
          sectionID = this.getAttribute(`nss-parent-section-id`);

    let markup = await (await fetch(`?section_id=${sectionID}`)).text();

    return parser.parseFromString(markup, "text/html");

    // (new DOMParser).parseFromString(await (await fetch(`?section_id=nss-cart-drawer`)).text(), "text/html")
  }

  updateItemCount(sectionEl) {
    const newProductListEl = sectionEl.querySelector(`.nss-cart__items`),
          itemCountEls = document.querySelectorAll(`[nss-cart-count]`);

    itemCountEls.forEach((itemCountEl) => {
      itemCountEl.innerHTML =
        newProductListEl.getAttribute(`nss-cart-item-count`);
    });

    this.updateCountBadges(newProductListEl.getAttribute(`nss-cart-item-count`));
  }

  updateCountBadges(result) {
    const count = parseInt(result, 10) || 0;
    if (this.debug) console.log(`[NSS][Cart Template] Updating badges, count:`, count);

    // Visible badge: empty string when 0 so the :empty CSS rule hides it.
    const countEls = document.querySelectorAll(`[nss-cart-badge-count]`);
    countEls.forEach((countEl) => {
      countEl.innerHTML = count > 0 ? (count < 100 ? count : `99+`) : ``;
    });

    // Screen-reader label stays in sync on every cart update.
    const labelEls = document.querySelectorAll(`[nss-cart-badge-label]`);
    labelEls.forEach((labelEl) => {
      labelEl.textContent = `${count} ${count === 1 ? `item` : `items`} in cart`;
    });
  }

  reloadElements(sectionEl) {
    const reloadEls = this.querySelectorAll(`[nss-cart-reload]`);

    reloadEls.forEach((reloadEl) => {
      const reloadID = reloadEl.getAttribute(`nss-cart-reload`),
            updatedEl = sectionEl.querySelector(`[nss-cart-reload="${reloadID}"]`);

      if (updatedEl) {
        reloadEl.replaceWith(updatedEl);
      } else {
        reloadEl.remove();
      }
    });
  }

  reloadItemList(sectionEl) {
    const productListEl = this.querySelector(`.nss-cart__items`),
          newProductListEl = sectionEl.querySelector(`.nss-cart__items`);

    productListEl.replaceWith(newProductListEl);
  }

  async handleATC(e) {
    const result = await this.apiAddToCart(e);
    if (this.debug) console.log(`[NSS][Cart Template] handleATC result:`, result);
    // Fold the addition into an existing subscription line of the same
    // variant (re-tiered by total quantity)
    await this.consolidateCart();
    // If the ATC form lives inside a modal (e.g. Quick Add), close it so the
    // cart drawer isn't covered by the modal that triggered the add.
    const sourceModal = e.target && e.target.closest && e.target.closest(`nss-modal`);
    if (sourceModal && typeof sourceModal.closeDialog === `function`) sourceModal.closeDialog();
    const sectionEl = await this.fetchCartSection();
    this.updateItemCount(sectionEl);
    this.reloadItemList(sectionEl);
    this.reloadElements(sectionEl);
    this.updateBlocks();
    this.refreshRecommendations();
    if (typeof window.NSS_OPEN_CART_DRAWER === `function`) window.NSS_OPEN_CART_DRAWER();
  }

  updateBlocks() {

    this.els.buyboxSummaries.forEach((buyboxSummaryEl) => {
      const event = new CustomEvent("buyboxReload", {});
      buyboxSummaryEl.dispatchEvent(event);
    });

    this.els.buyboxStickyATCs.forEach((buyboxStickyATCEl) => {
      const event = new CustomEvent("buyboxReload", {});
      buyboxStickyATCEl.dispatchEvent(event);
    });
  }

  async handleRemove(e) {
    // const cartItemEl = e.target.closest(`.nss-cart__item`);
    const cartItemEl = e.target.closest(`[nss-cart-item-key]`);
    const itemKey = cartItemEl.getAttribute(`nss-cart-item-key`);
    const bundleKeys = cartItemEl.getAttribute(`nss-cart-item-bundle-keys`)?.split(',') || [];

    let updates = {};

    if (bundleKeys.length > 0) {
      bundleKeys.map(key => {
        updates[key] = 0;
      });
    } else {
      updates[itemKey] = 0;
    }

    const result = await this.apiUpdate(updates);
    if (this.debug) console.log(`[NSS][Cart Template] handleRemove result:`, result);

    if (typeof result.status !== 'undefined') {
      const cartItemParentEl = cartItemEl.parentElement,
            cartErrorEl = cartItemParentEl.querySelector(`.nss-cart__item-error`);

      cartErrorEl.textContent = `Error: ${result.message}`;
      cartItemEl.setAttribute(`nss-cart-item-loading`, false);

      if (this.debug) console.log(`[NSS][Cart Template] Remove failed!`);
    } else {
      const sectionEl = await this.fetchCartSection();
      this.updateItemCount(sectionEl);
      this.reloadItemList(sectionEl);
      this.reloadElements(sectionEl);
      this.updateBlocks();
  
      if (this.debug) console.log(`[NSS][Cart Template] Remove completed!`);
    }
  }

  /**
   * Quantity-tier selling plan groups: each quantity tier (from the variant's
   * PDP metafield) has its own selling plan group. When a subscription line's
   * quantity moves into another tier, the line must switch to that tier
   * group's plan at the same frequency position.
   *
   * Reads the compact map rendered on the cart item
   * (nss-tier-plans="1:111|222;2:333|444;3:555|666") and the line's current
   * plan (nss-current-plan). Returns the selling plan id to switch to, or
   * null when no remap is needed (OTP line, no tier config, or same tier).
   */
  getTierPlanForQty(cartItemEl, newQty, planOverride) {
    const currentPlan = planOverride || cartItemEl.getAttribute(`nss-current-plan`);
    const mapAttr = cartItemEl.getAttribute(`nss-tier-plans`);
    if (!currentPlan || !mapAttr) return null;

    const tiers = mapAttr
      .split(`;`)
      .map((entry) => {
        const parts = entry.split(`:`);
        return {
          q: parseInt(parts[0], 10),
          plans: (parts[1] || ``).split(`|`).filter(Boolean),
        };
      })
      .filter((t) => !isNaN(t.q) && t.plans.length)
      .sort((a, b) => a.q - b.q);
    if (!tiers.length) return null;

    // Target tier: highest tier quantity <= newQty (tier 3 covers "3 and up")
    let target = null;
    tiers.forEach((t) => {
      if (t.q <= newQty) target = t;
    });
    if (!target) target = tiers[0];

    // Current tier + the plan's frequency position within it
    let current = null,
        freqIndex = 0;
    tiers.forEach((t) => {
      const i = t.plans.indexOf(currentPlan);
      if (i !== -1) {
        current = t;
        freqIndex = i;
      }
    });

    if (current && current.q === target.q) return null; // same group — keep plan
    return target.plans[freqIndex] || target.plans[0];
  }

  // Update a line's quantity, switching its selling plan to the matching
  // tier group's plan when needed.
  async applyQtyChange(cartItemEl, itemKey, qtyFinal) {
    const newPlan = this.getTierPlanForQty(cartItemEl, qtyFinal);
    if (newPlan) {
      return this.apiChange({
        id: itemKey,
        quantity: qtyFinal,
        selling_plan: newPlan,
      });
    }
    const updates = {};
    updates[itemKey] = qtyFinal;
    return this.apiUpdate(updates);
  }

  async handleQtyIncrement(e) {
    const cartItemEl = e.target.closest(`.nss-cart__item`),
          itemKey = cartItemEl.getAttribute(`nss-cart-item-key`),
          qtyInputEl = cartItemEl.querySelector(`[name="updates[]"]`);

    let qtyMax = parseInt(qtyInputEl.getAttribute(`max`)),
        qtyCurrent = parseInt(qtyInputEl.value),
        qtyFinal = Math.min(qtyCurrent + 1, qtyMax);

    const result = await this.applyQtyChange(cartItemEl, itemKey, qtyFinal);
    if (this.debug) console.log(`[NSS][Cart Template] handleQtyIncrement result:`, result);
    if (typeof result.status === 'undefined') await this.consolidateCart();

    if (typeof result.status !== 'undefined') {
      const cartItemParentEl = cartItemEl.parentElement,
            cartErrorEl = cartItemParentEl.querySelector(`.nss-cart__item-error`);

      cartErrorEl.textContent = `Error: ${result.message}`;
      cartItemEl.setAttribute(`nss-cart-item-loading`, false);

      if (this.debug) console.log(`[NSS][Cart Template] Quantity increment failed!`);
    } else {
      const sectionEl = await this.fetchCartSection();
      this.updateItemCount(sectionEl);
      this.reloadItemList(sectionEl);
      this.reloadElements(sectionEl);
      this.updateBlocks();
  
      if (this.debug) console.log(`[NSS][Cart Template] Quantity increment completed!`);
    }
  }

  async handleQtyDecrement(e) {
    const cartItemEl = e.target.closest(`.nss-cart__item`),
          itemKey = cartItemEl.getAttribute(`nss-cart-item-key`),
          qtyInputEl = cartItemEl.querySelector(`[name="updates[]"]`);

    let qtyMin = parseInt(qtyInputEl.getAttribute(`min`)),
        qtyCurrent = parseInt(qtyInputEl.value),
        qtyFinal = Math.max(qtyCurrent - 1, qtyMin);

    if (qtyFinal <= 0) {
      this.handleRemove(e);
      return;
    }

    const result = await this.applyQtyChange(cartItemEl, itemKey, qtyFinal);
    if (this.debug) console.log(`[NSS][Cart Template] handleQtyDecrement result:`, result);
    if (typeof result.status === 'undefined') await this.consolidateCart();

    if (typeof result.status !== 'undefined') {
      const cartItemParentEl = cartItemEl.parentElement,
            cartErrorEl = cartItemParentEl.querySelector(`.nss-cart__item-error`);

      cartErrorEl.textContent = `Error: ${result.message}`;
      cartItemEl.setAttribute(`nss-cart-item-loading`, false);

      if (this.debug) console.log(`[NSS][Cart Template] Quantity decrement failed!`);
    } else {
      const sectionEl = await this.fetchCartSection();
      this.updateItemCount(sectionEl);
      this.reloadItemList(sectionEl);
      this.reloadElements(sectionEl);
      this.updateBlocks();
  
      if (this.debug) console.log(`[NSS][Cart Template] Quantity decrement completed!`);
    }
  }

  async handleBXSY(e) {
    const cartItemEl = e.target.closest(`.nss-cart__item`),
          itemKey = cartItemEl.getAttribute(`nss-cart-item-key`),
          qtyInputEl = cartItemEl.querySelector(`[name="updates[]"]`);

    let targetQty = parseInt(e.target.getAttribute(`nss-bxsy-qty`), 10),
        qtyMax = parseInt(qtyInputEl.getAttribute(`max`)),
        qtyFinal = Math.min(targetQty, qtyMax);

    const result = await this.applyQtyChange(cartItemEl, itemKey, qtyFinal);
    if (this.debug) console.log(`[NSS][Cart Template] handleBXSY result:`, result);
    if (typeof result.status === 'undefined') await this.consolidateCart();

    if (typeof result.status !== 'undefined') {
      const cartItemParentEl = cartItemEl.parentElement,
            cartErrorEl = cartItemParentEl.querySelector(`.nss-cart__item-error`);

      cartErrorEl.textContent = `Error: ${result.message}`;
      cartItemEl.setAttribute(`nss-cart-item-loading`, false);

      if (this.debug) console.log(`[NSS][Cart Template] Buy X, Save Y failed!`);
    } else {
      const sectionEl = await this.fetchCartSection();
      this.updateItemCount(sectionEl);
      this.reloadItemList(sectionEl);
      this.reloadElements(sectionEl);
      this.updateBlocks();
  
      if (this.debug) console.log(`[NSS][Cart Template] Buy X, Save Y completed!`);
    }
  }

  /**
   * Cart consolidation — runs after every cart mutation. If a variant ends
   * up with MULTIPLE SUBSCRIPTION lines (e.g. different tier plans added
   * from the PDP), fold them into one: combined quantity, selling plan
   * re-tiered by the total (same frequency position). OTP lines are NEVER
   * touched — one-time + subscription of the same variant may coexist;
   * only the explicit "upgrade to subscription" button merges an OTP line.
   */
  async consolidateCart() {
    let cart;
    try {
      cart = await (await fetch(window.Shopify.routes.root + `cart.js`)).json();
    } catch (err) {
      console.error(`[NSS][Cart Template] consolidateCart fetch failed:`, err);
      return false;
    }
    if (!cart || !cart.items) return false;

    const byVariant = {};
    cart.items.forEach((item) => {
      (byVariant[item.variant_id] = byVariant[item.variant_id] || []).push(item);
    });

    let changed = false;
    for (const variantId in byVariant) {
      const lines = byVariant[variantId];
      if (lines.length < 2) continue;

      const subLines = lines.filter((l) => l.selling_plan_allocation);
      if (subLines.length < 2) continue;

      // Merge target: prefer a subscription line already rendered in the
      // drawer (it carries the tier map); cart.js lists newest first.
      const target =
        subLines.find((l) => this.querySelector(`[nss-cart-item-key="${l.key}"][nss-tier-plans]`)) ||
        subLines[0];

      // Only subscription quantities are combined — OTP lines stay as-is
      const totalQty = subLines.reduce((sum, l) => sum + l.quantity, 0);

      // Tier map can come from any rendered line of this variant
      const mapEl =
        this.querySelector(`[nss-cart-item-key="${target.key}"]`) ||
        this.querySelector(`.nss-cart__item[nss-cart-item-id="${variantId}"][nss-tier-plans]`);

      let mergedPlan = String(target.selling_plan_allocation.selling_plan.id);
      if (mapEl) {
        const tiered = this.getTierPlanForQty(mapEl, totalQty, mergedPlan);
        if (tiered) mergedPlan = tiered;
      }

      // Remove the other SUBSCRIPTION lines first (frees tracked inventory),
      // then move the total onto the target line with the re-tiered plan.
      const removal = {};
      subLines.forEach((l) => {
        if (l.key !== target.key) removal[l.key] = 0;
      });
      await this.apiUpdate(removal);
      await this.apiChange({ id: target.key, quantity: totalQty, selling_plan: mergedPlan });
      changed = true;
    }
    return changed;
  }

  // Another cart line with the same variant that already has a selling plan.
  // Used to merge lines instead of keeping two subscription lines of the
  // same product.
  findSubscriptionSibling(cartItemEl) {
    const variantId = cartItemEl.getAttribute(`nss-cart-item-id`),
          key = cartItemEl.getAttribute(`nss-cart-item-key`);
    let found = null;

    this.querySelectorAll(`.nss-cart__item`).forEach((el) => {
      if (found || el === cartItemEl) return;
      if (el.getAttribute(`nss-cart-item-id`) !== variantId) return;
      if (el.getAttribute(`nss-cart-item-key`) === key) return;
      const plan = el.getAttribute(`nss-current-plan`);
      if (plan) {
        found = { el: el, key: el.getAttribute(`nss-cart-item-key`), plan: plan };
      }
    });
    return found;
  }

  async handleFrequencyUpgrade(e) {
    const cartItemEl = e.target.closest(`.nss-cart__item`),
          itemKey = cartItemEl.getAttribute(`nss-cart-item-key`),
          qtyInputEl = cartItemEl.querySelector(`[name="updates[]"]`),
          sellingPlanId = e.target.getAttribute(`nss-selling-plan-id`);

    let qtyCurrent = parseInt(qtyInputEl.value),
        changes = {};

    // If a subscription line of the same variant already exists, MERGE into
    // it: one line, combined quantity, selling plan re-tiered by the total
    // (keeps the existing subscription's frequency position).
    const sibling = this.findSubscriptionSibling(cartItemEl);
    if (sibling) {
      const siblingQtyEl = sibling.el.querySelector(`[name="updates[]"]`),
            siblingQty = siblingQtyEl ? parseInt(siblingQtyEl.value, 10) || 0 : 0,
            totalQty = qtyCurrent + siblingQty,
            mergedPlan = this.getTierPlanForQty(sibling.el, totalQty) || sibling.plan;

      const mergeResult = await this.apiChange({
        id: sibling.key,
        quantity: totalQty,
        selling_plan: mergedPlan,
      });

      if (typeof mergeResult.status !== 'undefined') {
        const cartErrorEl = cartItemEl.parentElement.querySelector(`.nss-cart__item-error`);
        cartErrorEl.textContent = `Error: ${mergeResult.message}`;
        cartItemEl.setAttribute(`nss-cart-item-loading`, false);
        if (this.debug) console.log(`[NSS][Cart Template] Merge upgrade failed!`);
        return;
      }

      // Remove the (former OTP) line — its units now live on the sub line
      const removal = {};
      removal[itemKey] = 0;
      await this.apiUpdate(removal);

      const sectionEl = await this.fetchCartSection();
      this.updateItemCount(sectionEl);
      this.reloadItemList(sectionEl);
      this.reloadElements(sectionEl);
      if (this.debug) console.log(`[NSS][Cart Template] Merge upgrade completed!`);
      return;
    }

    changes["id"] = itemKey;
    changes["quantity"] = qtyCurrent;
    changes["selling_plan"] = sellingPlanId;

    const result = await this.apiChange(changes);
    if (this.debug) console.log(`[NSS][Cart Template] handleFrequencyUpgrade result:`, result);

    if (typeof result.status !== 'undefined') {
      const cartItemParentEl = cartItemEl.parentElement,
            cartErrorEl = cartItemParentEl.querySelector(`.nss-cart__item-error`);

      cartErrorEl.textContent = `Error: ${result.message}`;
      cartItemEl.setAttribute(`nss-cart-item-loading`, false);

      if (this.debug) console.log(`[NSS][Cart Template] Upgrade frequency failed!`);
    } else {
      const sectionEl = await this.fetchCartSection();
      this.reloadItemList(sectionEl);
      this.reloadElements(sectionEl);
  
      if (this.debug) console.log(`[NSS][Cart Template] Upgrade frequency completed!`);
    }
  }

  async handleFrequencyChange(e) {
    const cartItemEl = e.target.closest(`.nss-cart__item`),
          itemKey = cartItemEl.getAttribute(`nss-cart-item-key`),
          qtyInputEl = cartItemEl.querySelector(`[name="updates[]"]`);
    
    let sellingPlanId = e.target.value;
    if (e.target.hasAttribute(`nss-selling-plan-id`)) {
      sellingPlanId = e.target.getAttribute(`nss-selling-plan-id`);
    }
    
    let qtyCurrent = parseInt(qtyInputEl.value),
        changes = {};

    changes["id"] = itemKey;
    changes["quantity"] = qtyCurrent;
    changes["selling_plan"] = sellingPlanId;

    const result = await this.apiChange(changes);
    if (this.debug) console.log(`[NSS][Cart Template] handleFrequencyChange result:`, result);
    if (typeof result.status === 'undefined') await this.consolidateCart();

    if (typeof result.status !== 'undefined') {
      const cartItemParentEl = cartItemEl.parentElement,
            cartErrorEl = cartItemParentEl.querySelector(`.nss-cart__item-error`);

      cartErrorEl.textContent = `Error: ${result.message}`;
      cartItemEl.setAttribute(`nss-cart-item-loading`, false);

      if (this.debug) console.log(`[NSS][Cart Template] Change frequency failed!`);
    } else {
      const sectionEl = await this.fetchCartSection();
      this.reloadItemList(sectionEl);
      this.reloadElements(sectionEl);
  
      if (this.debug) console.log(`[NSS][Cart Template] Change frequency completed!`);
    }
  }

  startItemLoading(e) {
    const cartItemEl = e.target.closest(`.nss-cart__item`);
    if (!cartItemEl) return;
    cartItemEl.setAttribute(`nss-cart-item-loading`, true);
  }

  async refreshCart() {
    await this.consolidateCart();
    const sectionEl = await this.fetchCartSection();
    this.updateItemCount(sectionEl);
    this.reloadItemList(sectionEl);
    this.reloadElements(sectionEl);
    this.refreshRecommendations();
    if (typeof window.NSS_OPEN_CART_DRAWER === `function`) window.NSS_OPEN_CART_DRAWER();
  }

  initCartTemplate() {
    // Attach 'submit' events to nss-main as delegator
    const mainEl = document.querySelector(`[nss-main]`);

    window.NSS_REFRESH_AND_OPEN_CART = () => {
      this.refreshCart();
    };

    // Document-level listening for ATC events
    document.addEventListener(`submit`, (e) => {
      if (e.target.classList.contains(`shopify-product-form`) || e.target.getAttribute(`action`) === `/cart/add`) {
        e.preventDefault();
        if (this.debug) console.log(`[NSS][Cart Template] ATC form intercepted!`)
        this.handleATC(e);
      }
    });

    document.addEventListener(`click`, (e) => {
      let clickedName = e.target.getAttribute(`name`);

      if (this.debug) console.log(`[NSS][Cart Template] clickedName:`, clickedName);

      if (clickedName === "add") {
        e.preventDefault();
        if (this.debug) console.log(`[NSS][Cart Template] ATC button click intercepted!`);
        const fakeEvent = {
          target: e.target.closest(`form`),
        }
        this.handleATC(fakeEvent);
      }
    });

    // Attach other events to nss-cart-drawer as delegator
    this.addEventListener(`click`, (e) => {
      if (this.debug) console.log(`[NSS][Cart Template] CLicked, e.target:`, e.target);
      
      if (e.target.hasAttribute(`nss-frequency-drop-down`)) {
        e.target.classList.toggle(`nss-active`);
      }

      let eventType = e.target.getAttribute(`nss-cart-event`);

      switch (eventType) {
        case "bxsy-btn":
          e.preventDefault();
          if (this.debug) console.log(`[NSS][Cart Template] Buy X, Save Y event!`);
          this.startItemLoading(e);
          this.handleBXSY(e);
          break;

        case "remove":
          e.preventDefault();
          if (this.debug) console.log(`[NSS][Cart Template] Remove event!`);
          this.startItemLoading(e);
          this.handleRemove(e);
          break;

        case "qty-increment":
          e.preventDefault();
          if (this.debug) console.log(`[NSS][Cart Template] Quantity increment event!`);
          this.startItemLoading(e);
          this.handleQtyIncrement(e);
          break;

        case "qty-decrement":
          e.preventDefault();
          if (this.debug) console.log(`[NSS][Cart Template] Quantity decrement event!`);
          this.startItemLoading(e);
          this.handleQtyDecrement(e);
          break;

        case "frequency-upgrade":
          e.preventDefault();
          if (this.debug) console.log(`[NSS][Cart Template] Frequency upgrade event!`);
          this.startItemLoading(e);
          this.handleFrequencyUpgrade(e);
          break;

        case "frequency-change":
          // Native <select> is handled by the change listener — ignore its click
          if (e.target.tagName === "SELECT") break;
          e.preventDefault();
          if (this.debug) console.log(`[NSS][Cart Template] Frequency change event!`);
          this.startItemLoading(e);
          this.handleFrequencyChange(e);
          break;
      }
    });

    this.addEventListener(`change`, (e) => {
      let eventType = e.target.getAttribute(`nss-cart-event`);

      switch (eventType) {
        case "frequency-change":
          e.preventDefault();
          if (this.debug) console.log(`[NSS][Cart Template] Frequency change event!`);
          this.startItemLoading(e);
          this.handleFrequencyChange(e);
          break;
      }
    });

    // prepareRecommendations
    this.prepareRecommendations();
  }

  refreshRecommendations() {
    const productRecommendationsEls = document.querySelectorAll(`[nss-recommendations-id]`);
    productRecommendationsEls.forEach((productRecommendationsEl) => {
      const url = productRecommendationsEl.dataset.url;
      const id = productRecommendationsEl.getAttribute(`nss-recommendations-id`);

      productRecommendationsEl.setAttribute(`nss-recommendations-loading`, true);
    
      fetch(url)
        .then(response => {
          productRecommendationsEl.setAttribute(`nss-recommendations-loading`, false);
          return response.text();
        })
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector(`[nss-recommendations-id="${id}"]`);
  
          if (recommendations && recommendations.innerHTML.trim().length) {
            productRecommendationsEl.innerHTML = recommendations.innerHTML;
            productRecommendationsEl.style.display = `flex`;
          }
        })
        .catch(e => {
          productRecommendationsEl.style.display = `none`;
          console.error(e);
        });
    });
  }

  prepareRecommendations() {
    const productRecommendationsEls = document.querySelectorAll(`[nss-recommendations-id]`);
    productRecommendationsEls.forEach((productRecommendationsEl) => {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
    
        observer.unobserve(productRecommendationsEl);
    
        const url = productRecommendationsEl.dataset.url;
        const id = productRecommendationsEl.getAttribute(`nss-recommendations-id`);
        productRecommendationsEl.setAttribute(`nss-recommendations-loading`, true);

        if (this.debug) console.log(`[NSS][Cart Template] Recommendations url:`, url);
        if (this.debug) console.log(`[NSS][Cart Template] Recommendations id:`, id);
    
        fetch(url)
          .then(response => {
            productRecommendationsEl.setAttribute(`nss-recommendations-loading`, false);
            return response.text();
          })
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector(`[nss-recommendations-id="${id}"]`);
    
            if (recommendations && recommendations.innerHTML.trim().length) {
              productRecommendationsEl.innerHTML = recommendations.innerHTML;
              productRecommendationsEl.style.display = `flex`;
            } else {
              productRecommendationsEl.style.display = `none`;
            }
          })
          .catch(e => {
            productRecommendationsEl.style.display = `none`;
            console.error(e);
          });
      };
      const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
      observer.observe(productRecommendationsEl);
    });
  }
}

let elementName = `nss-cart-template`;
if (typeof customElements.get(elementName) === `undefined`) {
  customElements.define(elementName, NSSCartTemplate);
} else {
  console.warn(`[NSS] Element '${elementName}' already defined.`)
}
